import { types, Instance, getParent } from 'mobx-state-tree'
import { IView } from 'src/api/misc/View/types'
import { Sideview } from 'src/api/misc/View/Sideview'
import { fromGlobalId } from 'src/api/utils/globalId'
import {
  contentEdge,
  coverEdge,
  elementEdge,
  project
} from 'src/constants/typenames'
import { ElementEdge } from 'src/api/models/Elements'
import { CoverEdge } from 'src/api/models/Enclosure'
import { ContentEdge } from 'src/api/models/Content'
import { Project } from 'src/api/models/Project'
import { ISelectedItem, ISelectedItemReference } from './types'
import { ICoverEdge } from 'src/api/models/Enclosure/Cover/types'
import { IContentEdge } from 'src/api/models/Content/ContentEdge/types'
import { IProject } from 'src/api/models/Project/types'
import { IElementEdge } from 'src/api/models/Elements/ElementEdge/types'

const selectableItemUnion = types.union(
  types.late(ElementEdge) as IElementEdge,
  ContentEdge,
  types.late(CoverEdge),
  types.late(Project)
)

export const SelectedItemReference: ISelectedItemReference = types.maybeNull(
  types.reference(selectableItemUnion, {
    get(
      identifier: string,
      sideview: Instance<typeof Sideview>
    ): typeof selectableItemUnion | null {
      // 2. Editor 1. types.map 0. EditorSideview
      const parent = getParent<Instance<IView>>(sideview, 2) // View as Placeholder for Editor
      const { type } = fromGlobalId(identifier) as {
        type: ISelectedItem['__typename']
      }
      let result:
        | Instance<IContentEdge>
        | Instance<ICoverEdge>
        | Instance<IProject>
        | Instance<IElementEdge>

      switch (type) {
        case contentEdge:
          const edge = parent.draft.content.edges[0]
          if (edge.id === identifier) result = edge
          break
        case coverEdge:
          const coverInstance = parent.draft.enclosure.coverEdges[0]
          if (coverInstance.id === identifier) result = coverInstance
          break
        case elementEdge:
          parent.draft.enclosure.coverEdges[0].node.plates.edges.forEach(
            ({ node }) => {
              const element = node.elements.edges.find(
                ({ id }) => id === identifier
              )
              if (element !== undefined) {
                result = element
              }
            }
          )
          break
        case project:
          if (parent.draft.id === identifier) result = parent.draft
          break
      }
      return result
    },
    set(item) {
      return item.id
    }
  })
)
